import { render, staticRenderFns } from "./DataOverview.vue?vue&type=template&id=444e8734&scoped=true&"
import script from "./DataOverview.vue?vue&type=script&lang=js&"
export * from "./DataOverview.vue?vue&type=script&lang=js&"
import style0 from "./DataOverview.vue?vue&type=style&index=0&id=444e8734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e8734",
  null
  
)

export default component.exports